import { Field, Input, makeStyles, mergeClasses, Slot } from '@fluentui/react-components';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { useCommonStyles } from '../../../common/hooks';

interface FormattedInputProps {
  prefix: string;
  value: string;
  onChange: (newValue: string) => void;
  label?: string;
  maxLength?: number;
  isValidated?: boolean;
  errorText?: Slot<'div'>;
  disabled?: boolean;
  required?: boolean;
  isViewOnly?: boolean;
  className?: string;
  contentAfter?: Slot<'span'>;
  orientation?: 'horizontal' | 'vertical';
  ariaLabelledBy?: string;
}

const DEFAULT_MAX_LENGTH = 524288;

const useStyles = makeStyles({
  inputField: { paddingRight: 0 },
});

const FormattedInputImpl: React.FC<FormattedInputProps> = (props) => {
  const {
    prefix,
    label,
    value,
    onChange,
    errorText,
    maxLength,
    isValidated,
    disabled,
    required,
    isViewOnly,
    className,
    contentAfter,
    orientation,
    ariaLabelledBy,
  } = props;

  const [formElementVisited, setFormElementVisited] = useState<{ [inputName: string]: boolean }>({});

  const commonStyles = useCommonStyles();
  const styles = useStyles();

  return (
    <Field
      orientation={orientation}
      className={`${className ? className : ''} formatted-input`}
      label={label ? {
        children: label,
        className: commonStyles.inputFieldLabel,
      } : undefined}
      validationMessageIcon={null}
      validationMessage={((isValidated || formElementVisited[label ?? '']) && !isViewOnly) ? errorText : null}
    >
      <Input
        aria-labelledby={ariaLabelledBy}
        className={contentAfter ? mergeClasses(commonStyles.inputField, styles.inputField) : commonStyles.inputField}
        contentBefore={prefix}
        contentAfter={contentAfter}
        disabled={disabled}
        required={required}
        value={value.indexOf(prefix) >= 0 ? value.slice(prefix.length) : value}
        maxLength={maxLength || DEFAULT_MAX_LENGTH}
        readOnly={isViewOnly}
        onChange={event => {
          const input = event.target.value;
          onChange(`${prefix}${input.indexOf(prefix) >= 0 ? input.slice(prefix.length) : input}`);
        }}
        onBlur={() => setFormElementVisited({ ...formElementVisited, [label ?? '']: true })}
      />
    </Field>
  );
}

export const FormattedInput = observer(FormattedInputImpl);
